import { CheckOutlined, CloseOutlined, CopyOutlined, EditOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'
import { Input, message, Space } from 'antd'
import React, { KeyboardEvent, ReactNode, useEffect, useRef, useState } from 'react'
import swal from 'utils/swal'
import { copyToClipboard } from 'utils/utils'

interface IProps {
  value?: string
  onChange?: (value: string) => void
  readOnly?: boolean
  placeholder?: string
  defaultRevealed?: boolean
  onEdit?: () => void
  editing?: boolean
  onCancel?: () => void
  concealed?: boolean
}

function IconAction ({ label, onClick, children }: { label: string, onClick: () => void, children: ReactNode }) {
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onClick()
  }

  return <span className="ant-input-password-icon" role="button" tabIndex={0} aria-label={label} title={label} onClick={onClick} onKeyDown={onKeyDown}>{children}</span>
}

export default function SecretInput ({ value, onChange, readOnly, placeholder, defaultRevealed = false, onEdit, editing = false, onCancel, concealed = false }: IProps) {
  const [revealed, setRevealed] = useState(defaultRevealed)
  const [copied, setCopied] = useState(false)
  const copiedTimer = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => () => clearTimeout(copiedTimer.current as ReturnType<typeof setTimeout>), [])

  const copy = async () => {
    if (!value) return
    try {
      await copyToClipboard(value)
      message.success('Copiado para a área de transferência')
      setCopied(true)
      clearTimeout(copiedTimer.current as ReturnType<typeof setTimeout>)
      copiedTimer.current = setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      swal.basic({ icon: 'error', title: 'Não foi possível copiar', text: 'Copie o valor manualmente.' })
    }
  }

  const edit = () => {
    setRevealed(true)
    if (onEdit) onEdit()
  }

  const cancel = () => {
    setRevealed(false)
    if (onCancel) onCancel()
  }

  return (
    <Input
      type={revealed ? 'text' : 'password'}
      autoComplete="new-password"
      value={value}
      readOnly={readOnly}
      placeholder={placeholder}
      onChange={(event) => onChange?.(event.target.value)}
      suffix={
        <Space size="middle">
          {!concealed && (revealed
            ? <IconAction label="Ocultar" onClick={() => setRevealed(false)}><EyeInvisibleOutlined /></IconAction>
            : <IconAction label="Revelar" onClick={() => setRevealed(true)}><EyeOutlined /></IconAction>)}
          {!concealed && <IconAction label="Copiar" onClick={copy}>{copied ? <CheckOutlined /> : <CopyOutlined />}</IconAction>}
          {onEdit && (editing && onCancel
            ? <IconAction label="Cancelar" onClick={cancel}><CloseOutlined /></IconAction>
            : <IconAction label="Editar" onClick={edit}><EditOutlined /></IconAction>)}
        </Space>
      }
    />
  )
}
